// extracted by mini-css-extract-plugin
module.exports = {"label":"_2dsmYV7Z1lWUNnCT_5DmBT","active":"_11tgqQm6XWujkPpdkPck9q"};